/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Address,
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    InMerchantNetwork,
    InMerchantNetworkFromJSON,
    InMerchantNetworkFromJSONTyped,
    InMerchantNetworkToJSON,
    Merchant,
    MerchantFromJSON,
    MerchantFromJSONTyped,
    MerchantToJSON,
    MerchantStatus,
    MerchantStatusFromJSON,
    MerchantStatusFromJSONTyped,
    MerchantStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface MerchantSearchMerchant
 */
export interface MerchantSearchMerchant {
    /**
     * The merchant unique identifier.
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    merchantId: string;
    /**
     * The merchant name.
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    name?: string;
    /**
     * 
     * @type {Address}
     * @memberof MerchantSearchMerchant
     */
    address?: Address;
    /**
     * 
     * @type {MerchantStatus}
     * @memberof MerchantSearchMerchant
     */
    merchantStatus?: MerchantStatus;
    /**
     * 
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    timezone?: string;
    /**
     * The preferred locale used for communication, in BCP 47 format.
     * @type {string}
     * @memberof MerchantSearchMerchant
     */
    locale?: string;
    /**
     * Whether merchant is in the merchant network.
     * @type {boolean}
     * @memberof MerchantSearchMerchant
     */
    inMerchantNetwork?: boolean;
}

export function MerchantSearchMerchantFromJSON(json: any): MerchantSearchMerchant {
    return MerchantSearchMerchantFromJSONTyped(json, false);
}

export function MerchantSearchMerchantFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantSearchMerchant {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'merchantId': json['merchantId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'merchantStatus': !exists(json, 'merchantStatus') ? undefined : MerchantStatusFromJSON(json['merchantStatus']),
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'inMerchantNetwork': !exists(json, 'inMerchantNetwork') ? undefined : json['inMerchantNetwork'],
    };
}

export function MerchantSearchMerchantToJSON(value?: MerchantSearchMerchant | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'merchantId': value.merchantId,
        'name': value.name,
        'address': AddressToJSON(value.address),
        'merchantStatus': MerchantStatusToJSON(value.merchantStatus),
        'timezone': value.timezone,
        'locale': value.locale,
        'inMerchantNetwork': value.inMerchantNetwork,
    };
}


